<template>
  <div>
    <div
      class="cover"
      :style="{ backgroundImage: 'url(' + img_api + pageData.bannerImg + ')' }"
    >
      <div class="front">
        <div class="title">
          <div class="big_title">
            {{ pageData.firstTitle }}
          </div>
          <div class="transparent_title">{{ pageData.secondTitle }}</div>
        </div>
        <div class="des">
          {{ pageData.des }}
        </div>
      </div>
    </div>
    <div class="bread_box">
      <div class="crumb">
        <span class="your_position">您所在的位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/operation' }"
            >{{ pageData.firstTitle }}{{ pageData.secondTitle }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="head">
      <div class="return_button" @click="goBack">返回列表页</div>
      <div class="news_data">
        <div class="news_title">{{ detail.name }}</div>
        <!-- <div class="news_type">型号：{{ detail.englishName }}</div> -->
      </div>
    </div>
    <div class="news_page">
      <div class="news_content">
        <div class="big_img_box" @mouseenter="isShow = true"
      @mouseleave="isShow = false">
          <img class="big_img" :src="img_api + img" alt="" />
          <transition name="fade">
            <div v-show="isShow">
              <div class="right_btn" @click="next_img">
                <img src="../assets/img/right_btn.png" alt="" />
              </div>
              <div class="left_btn" @click="return_img">
                <img src="../assets/img/left_btn.png" alt="" />
              </div>
              <div class="sum">
                {{ tabIndex }} /{{ detail.imageList.length }}
              </div>
            </div>
          </transition>
        </div>
        <div class="small_img_box">
          <div
            class="small_img"
            v-for="item in detail.imageList"
            :key="item.id"
            @click="toBig(item)"
            :class="item.id == tabIndex ? ' blue_border' : ''"
          >
            <img :src="img_api + item.url" alt="" />
          </div>
        </div>
        <p class="content_front">
          {{ detail.details }}
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import { getAsphaltDetails } from "@/server/https.js";
export default {
  name: "",
  pageData: {},
  data() {
    return {
        isShow:false,
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      tabIndex: 1,
      img: "",
      img_api: "https://www.gdyuanwo.com/gdyuanwo/",
      detail: {},
      tabsList: [
        { id: 0, title: "商品详情" },
        { id: 1, title: "详细参数" },
      ],
    };
  },
  beforeMount() {
    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 5) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
  },
  mounted() {
    getAsphaltDetails({ id: this.$route.query.id }).then((res) => {
      this.detail = res.data.body.data;
      this.img = res.data.body.data.imageList[0].url;
    });
  },
  methods: {
    //返回上一层
    goBack() {
      this.$router.go(-1); // 返回上一个路由
    },
    //点击缩略图
    toBig(item) {
      this.tabIndex = item.id;
      this.img = item.url;
    },
    //下一张图片
    next_img() {
      if (this.tabIndex < this.detail.imageList.length) {
        this.tabIndex++;
        let object1 = this.detail.imageList.find(
          (item) => item.id == this.tabIndex
        );
        this.img = object1.url;
      }
    },
    //上一张图片
    return_img() {
      if (this.tabIndex > 1) {
        this.tabIndex--;
        let object1 = this.detail.imageList.find(
          (item) => item.id == this.tabIndex
        );
        this.img = object1.url;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true;
    next(0);
  },
};
</script>

<style scoped>
.cover {
  overflow: hidden;
  height: 355px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.front {
  margin-top: 72px;
  margin-left: 240px;
}

.title {
  display: flex;
}

.big_title {
  font-size: 68px;
  font-weight: bold;
  color: #ffffff;
}

.hight_title {
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
}

.transparent_title {
  font-size: 68px;
  font-weight: bold;
  color: rgba(255, 255, 255, 0);
  color: rgba(255, 255, 255, 0);
  -webkit-text-stroke: 1px #ffffff;
  text-stroke: 1px #ffffff;
}

.des {
  font-size: 24px;
  color: #ffffff;
}

.bread_box {
  overflow: hidden;
  height: 60px;
  background-color: #f7f8fa;
}

.crumb {
  display: flex;
  margin-top: 23px;
  margin-left: 140px;
}

.your_position {
  line-height: 1;
  font-size: 14px;
  font-weight: 400;
  color: #13489d;
  margin-right: 5px;
}

.news_page {
  /* position: relative; */
  width: 1000px;
  margin: auto;
}

.content_row {
  display: flex;
  width: 100%;
  height: 15px;
  margin: 10px 0;
}

.content_title {
  line-height: 15px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.colum {
  width: 5px;
  height: 100%;
  margin-right: 20px;
  background-color: #13489d;
}

.head {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 56px;
}

.return_button {
  width: 140px;
  height: 48px;
  background: #ffffff;
  border: 1px solid #5877ba;
  font-size: 18px;
  font-weight: 400;
  color: #13489d;
  line-height: 48px;
  text-align: center;
  position: absolute;
  left: 173px;
}

.return_button {
  cursor: pointer;
}

.news_content {
  margin-top: 3.5rem;
}

.big_img_box {
  position: relative;
  display: flex;
  width: 100%;
  height: 600px;
}

.big_img {
  width: 100%;
  height: 100%;
}

.small_img_box {
  display: flex;
  margin-top: 20px;
  width: 100%;
  height: 72px;
  /* background-color: rgb(249, 144, 144); */
}

.small_img {
  width: 96px;
  height: 72px;
  margin-right: 10px;
  border: 2px solid #eeeeee;
}

.blue {
  color: #13489d;
  border-bottom: 4px solid #13489d;
}

.blue_border {
  border: 2px solid #13489d;
}

.small_img img {
  width: 100%;
  height: 100%;
}

.right_btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translate(10px, -30px);
  z-index: 2200;
  width: 35px;
  height: 35px;
}

.right_btn img {
  width: 100%;
  height: 100%;
}

.left_btn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(10px, -30px);
  z-index: 2200;
  width: 35px;
  height: 35px;
}

.left_btn img {
  width: 100%;
  height: 100%;
}

.sum {
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 48px;
  height: 26px;
  background: #000000;
  border-radius: 13px;
  opacity: 0.24;
  text-align: center;
  line-height: 26px;
  color: #ffffff;
}

.content_front {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  text-indent: 25px;
  line-height: 2;
  margin-top: 30px;
  margin-bottom: 100px;
}

.content_bottom {
  overflow: hidden;
  position: relative;
  width: 100%;
  margin: 30px auto;
  background-color: #f9f9fd;
  padding-bottom: 100px;
}

.tab_content {
  width: 1000px;
  /* height: 1000px; */
  margin: 30px auto;
  background-color: #fff;
}

.tabs {
  height: 60px;
  line-height: 60px;
  display: flex;
  margin-left: 50px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.tabs div {
  margin-left: 40px;
}

.contents {
  width: 800px;
  height: 100%;
  padding-bottom: 100px;
  margin: 30px auto;
  /* background-color: rgb(238, 108, 108); */
}

.contents img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.btn {
  position: absolute;
  width: 140px;
  height: 48px;
  left: 0;
  right: 0;
  background: #13489d;
  font-weight: 400;
  color: #ffffff;
  margin: auto;
}

.pag {
  float: right;
  margin-bottom: 40px;
  margin-right: 200px;
}
.news_title {
  display: flex;
  justify-content: center;
  font-size: 24px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 10px;
}

.news_data {
  display: flex;
  justify-content: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  opacity: 0.5s;
}
</style>
